// 代理领奖提示
import { isMobile } from "@/lib/isMobile.ts";

export default function AffiliateClaiTip(props: { class?: string }) {
  return (
    <div class="relative h-full">
      <div class={`absolute ${props.class}`}>
        <div
          class={`bg-general-tips rounded-full ${isMobile() ? "size-[6px]" : "size-[7px]"}`}
        ></div>
      </div>
    </div>
  );
}
